import Marquee from "react-fast-marquee";

const ITEMS = [
  "Premium detailing",
  "We come to you",
  "Drop-off available",
  "Pay in person",
  "Locally trusted",
];

export default function Ribbon() {
  return (
    <div className="border-y border-ink/10 bg-cream py-5" data-testid="marquee-ribbon">
      <Marquee speed={26} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <span key={i} className="mx-6 flex items-center gap-6 text-sm font-medium uppercase tracking-[0.2em] text-ink/50">
            {t}
            <span className="text-ink/25">/</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
